import { NgModule } from '@angular/core'
import { FloSanitizeHtmlPipe } from './sanitize-html.pipe'

@NgModule({
  declarations: [FloSanitizeHtmlPipe],
  exports: [FloSanitizeHtmlPipe]
})
export class FloSanitizeHtmlPipeModule {}
